import { useState } from 'react';
import { useShell } from '../../shell-context.js';
import { PortCallDetail } from './PortCallDetail.js';
import { PortCallForm } from './PortCallForm.js';
import { PortCallList } from './PortCallList.js';
import { type PortCallRoute, portCallPath } from './port-calls.js';
import type { PortCallsSource } from './source.js';

export interface PortCallsScreenProps {
  source: PortCallsSource;
  /** Sorgu dizesinden (`portCallRoute`). */
  route: PortCallRoute;
}

/**
 * Operations ▸ Port Calls (M13f; ADR 0052): liste, ayrıntı ve form (yalnız gemide). Görünüm yolun
 * sorgu dizesinden gelir; ekran gemi uygulamasında ve web ofiste aynıdır (ADR 0019 §2).
 */
export function PortCallsScreen({ source, route }: PortCallsScreenProps) {
  const shell = useShell();
  const [message, setMessage] = useState<string | null>(null);
  const go = (next: PortCallRoute, notice: string | null = null) => {
    setMessage(notice);
    shell?.navigate(portCallPath(next));
  };
  const editor = source.editor;

  if ((route.view === 'new' || route.view === 'edit') && editor) {
    return (
      <PortCallForm
        key={route.view === 'edit' ? route.id : 'new'}
        source={source}
        editor={editor}
        callId={route.view === 'edit' ? route.id : null}
        onDone={(id, notice) => go({ view: 'detail', id }, notice)}
        onCancel={() =>
          go(route.view === 'edit' ? { view: 'detail', id: route.id } : { view: 'list' })
        }
      />
    );
  }
  if (route.view === 'detail' || route.view === 'edit') {
    return (
      <PortCallDetail
        key={`${route.id}-${message ?? ''}`}
        source={source}
        id={route.id}
        message={message}
        onBack={() => go({ view: 'list' })}
        onEdit={() => go({ view: 'edit', id: route.id })}
      />
    );
  }
  return (
    <PortCallList
      source={source}
      onOpen={(id) => go({ view: 'detail', id })}
      onNew={() => go({ view: 'new' })}
    />
  );
}
